// What the page exposes in DEV (`src/platforms/web/src/main.tsx`): the plugin
// registry and the setup results, as `window.__host`. The assignment happens
// after every plugin's `setup` has run, so it is read when needed, never at
// setup time.

/** The registry's methods the bridge uses; the class itself is the platform's own. */
export interface HostRegistry {
  tryGetApi<T>(name: string): T | undefined;
  getApi<T>(name: string): Promise<T>;
  subscribe(watcher: () => void): () => void;
  notifications(): readonly HostNotification[];
  pages(): readonly { route: string; pilet: string }[];
  extensions(slot: string): readonly { pilet: string; defaults: unknown }[];
}

export interface HostNotification {
  id: number;
  content: unknown;
  options: { title?: string; autoClose?: number; type?: string };
  pilet: string;
}

export interface Host {
  registry: HostRegistry;
  loaded: unknown;
}

export function hostOf(scope: unknown): Host | undefined {
  return (scope as { __host?: Host }).__host;
}
